import React from 'react'
import { Card, CardText, LinearProgress } from 'react-md'

const UploadProgress = ({ status: { progress, uploaded, total } }) => (
  <Card className='upload-progress'>
    <CardText className='upload-left'>
      { uploaded === total ? 'Send Complete' : 'Uploading' }
    </CardText>
    <CardText className='upload-right'>
      {`Sent ${uploaded} of ${total} artworks`}
    </CardText>
    <LinearProgress id='upload-progress' value={progress || 0} />
  </Card>
)

export default UploadProgress



// WEBPACK FOOTER //
// ./src/containers/Upload/UploadProgress.js